
<template>
  <div class="layout" id="topics">
    <h2>台灣樂團專題文章一覽</h2>
    <h3 class="pc"></h3>
    <h3 class="mb">下滑看更多文章</h3>

    <div class="slayout">
      <a v-for="(item, index) in news" :key="index" class="hot_news_layout"
        :href="'https://www.ftvnews.com.tw/news/detail/' + item.ID" target="_blank">
        <div class="hot_news_inner p1">
          <p class="hot_news_title">&nbsp;&nbsp;<i class="fa-light fa-hand-horns"></i>&nbsp;&nbsp;{{
            item.Title.replace('台灣樂團專題／', '') }}
          </p>
        </div>
      </a>
    </div>
  </div>
</template>


<script>
/*eslint-disable*/
$(document).ready(function () {
  $('h3').click(function (e) {
    $('.slayout').css("height", "100%");
  })

});
export default {
  data() {
    return {
      news: [],
      news1: [],
      news2: [],
    }
  },
  methods: {
    fetchNews() {
      var myHeaders = new Headers();
      myHeaders.append("TokenKey", "z1x2c3v4b5n6m78i9o0pftv8859");
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch("https://ftvapi2.ftvnews.com.tw/API/FtvGetNewsWebV2.aspx?Cate=台灣樂團專題", requestOptions)
        .then(response => response.json())
        .then(result => {
          console.log(result);
          this.news = result.ITEM;
        })
        .catch(error => console.log('error', error));
    },
  },
  mounted() {
    this.fetchNews();

  }
}
</script>

<style scoped>
.slayout {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: auto;
}



@media screen and (max-width:768px) {
  .slayout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    overflow-x: hidden;
    overflow-y: scroll;
    height: 370px;
  }


}

@media screen and (max-width:500px) {
  .slayout {
    display: grid;
    grid-template-columns: 1fr;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 370px;
  }

}

.swiper {
  margin: auto;
}





h3 {
  text-align: center;
}



p {
  position: relative;
  border: 2px;
  border-radius: 100px;
  background-color: rgb(249, 214, 131, .9);
  width: 90%;
  padding: .3rem .4rem .26rem;
  display: flex;
  justify-content: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  margin: .5rem;
  font-size: 1rem;
  font-weight: bold;
}



.hot_news_title:hover {
  filter: drop-shadow(0px 0px 10px rgba(255, 184, 17, 0.5));
}

swiper-slide {
  padding: 100px;

}

.swipersection {
  padding: .5rem;
  margin: auto 1rem;
}

@media screen and (max-width:500px) {
  .swipersection {
    padding: .5rem;
    margin: auto 1.5rem;
  }
}
</style>
